import styled from "styled-components";
import { remCalc } from "utilities/styles";
import { aboveMedium } from "utilities/variables/media";

export const LandingPageWrapper = styled.div`

  @media ${aboveMedium} {
    margin-bottom: ${remCalc(32)};
  }
  

`;